module.exports = __webpack_public_path__ + "img/indonesia.254c28d7.png";